import React, { createContext, useContext, useState, useCallback } from 'react';

interface TooltipContextType {
  activeTooltipId: string | null;
  setActiveTooltip: (id: string | null) => void;
}

const TooltipContext = createContext<TooltipContextType | undefined>(undefined);

export const TooltipProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeTooltipId, setActiveTooltipId] = useState<string | null>(null);

  const setActiveTooltip = useCallback((id: string | null) => {
    setActiveTooltipId(id);
  }, []);

  return (
    <TooltipContext.Provider value={{ activeTooltipId, setActiveTooltip }}>
      {children}
    </TooltipContext.Provider>
  );
};

export const useTooltip = () => {
  const context = useContext(TooltipContext);
  if (context === undefined) {
    throw new Error('useTooltip must be used within a TooltipProvider');
  }
  return context;
};
